import routes from 'global/Constants/routes';
import { lazy } from 'react';

const Profile = lazy(() => import('../../pages/dashboard/profile/Profile'));

export const profileRoutes = (hasAccessLevel: (_level: number) => boolean) => [
  {
    path: routes.profile.path,
    component: Profile,
    isPrivate: routes.profile.isPrivate,
    accessRole: hasAccessLevel(10),
  },
];
